"use client";

import { FC, useEffect, useState } from "react";
import classNames from "classnames";
import Image from "next/image";
import { useTranslations } from "next-intl";
import ReactPlayer from "react-player/lazy";

import { Caption } from "components/atoms/Caption/Caption";
import { Modal } from "components/molecules/Modal/Modal";

import { VideoRecord } from "@graphql/types/graphql";
import s from "./Video.module.scss";

interface Props {
  data: VideoRecord;
  showInModal?: boolean;
}

export const Video: FC<Props> = ({ data: { video, author, authorFunction }, showInModal }) => {
  const t = useTranslations("common");

  const [hasWindow, setHasWindow] = useState(false);
  const [showVideo, setShowVideo] = useState(false);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    /*
     * Next.js throws an error when loading iframe and window does not exist
     */
    if (typeof window !== "undefined") {
      setHasWindow(true);
    }
  }, []);

  return (
    <div
      className={classNames(s.Video, {
        [s.IsModal]: showInModal,
      })}
    >
      {!showVideo && (
        <button
          className={s.Placeholder}
          type="button"
          onClick={() => {
            if (showInModal) {
              setShowModal(true);
            } else {
              setShowVideo(true);
            }
          }}
          aria-label={t("play")}
        >
          <Image src={video.thumbnailUrl} alt={video.title} layout="fill" objectFit="cover" />
        </button>
      )}
      {hasWindow && showVideo && (
        <div className={s.ReactPlayerWrapper}>
          <ReactPlayer
            url={video.url}
            width="100%"
            height="100%"
            className={s.ReactPlayer}
            playing
          />
        </div>
      )}
      {(author || authorFunction) && (
        <Caption author={author ?? undefined} authorFunction={authorFunction ?? undefined} />
      )}
      {showModal && (
        <Modal open={showModal} onClose={() => setShowModal(false)}>
          <div className={s.PlayerModal}>
            <div className={s.ReactPlayerWrapper}>
              <ReactPlayer
                url={video.url}
                width="100%"
                height="100%"
                className={s.ReactPlayer}
                playing
                controls
              />
            </div>
          </div>
        </Modal>
      )}
    </div>
  );
};
